export var getParentNodeWidth = function getParentNodeWidth(element) {
  var _global = global,
      Math = _global.Math,
      getComputedStyle = _global.getComputedStyle,
      parseInt = _global.parseInt;
  return Math.floor(element.parentNode.offsetWidth - parseInt(getComputedStyle(element.parentNode).paddingLeft, 10) - parseInt(getComputedStyle(element.parentNode).paddingRight, 10));
};